import _ from 'underscore';
import Backbone from 'backbone';

  var incidents = new Backbone.Collection();
  _.extend(incidents, {
    url : 'https://electricimp.statuspage.io/api/v2/incidents/unresolved.json',
    parse : function(resp) {
      return resp.incidents;
    },
    type: 'incident'
  });
  export default incidents;

